import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Session {
  id: number;
  day_number: number;
  title: string;
  description: string;
  category: string;
  duration: string;
  video_url: string | null;
}

export function useSessions() {
  return useQuery({
    queryKey: ["sessions"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("sessions")
        .select("*")
        .order("day_number");
      if (error) throw error;
      return data as Session[];
    },
    staleTime: 5 * 60 * 1000,
    refetchOnMount: "always",
  });
}
